<!-- Notifications toggle -->
<div>
    <button matIconButton (click)="openPanel()" #notificationsOrigin>
        @if (unreadCount > 0) {
        <span class="notification-unreadcount" >
            <div class="notification-unreadcount-badge">
                {{ unreadCount }}
            </div>
        </span>
        }
        <i class="fa-regular fa-bell"></i>
    </button>
</div>

<!-- Notifications panel -->
<ng-template #notificationsPanel>
    <div class="notification-panel">
        <!-- Header -->
        <div class="notification-panel-header">
            <div style="margin-left: -0.25rem; margin-right: 0.75rem">
                <button matIconButton (click)="closePanel()">
                    <mat-icon class="header-icon">close</mat-icon>
                </button>
            </div>
            <div style="font-size: 1.125rem; line-height: 2.5rem; font-weight: 500">
                Messaggi
            </div>
            <!-- <div style="margin-left: auto;">
                <button class="tooltip-dark-text" matIconButton [matTooltip]="'Vai a tutti i messaggi'"
                    (click)="goToMessagesList()">
                    <mat-icon class="header-icon">menu</mat-icon>
                </button>
                <button class="tooltip-dark-text" matIconButton [matTooltip]="'Segna tutto come letto'"
                    [disabled]="unreadCount === 0" (click)="markAllAsRead()">
                    <mat-icon class="header-icon">drafts</mat-icon>
                </button>
            </div> -->
        </div>

        <!-- Content -->
        <div class="notification-panel-content">
            <!-- Notifications -->
            @for (message of messages; track $index) {
                <div class="notification"> <!-- [ngClass]="{ unread: !message.read }" -->

                    <!-- Notification with link -->
                    @if (message.link) {
                        <a class="notification-container" style="cursor: pointer;" [href]="message.link" (click)="this.toggleRead(message)">
                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                        </a>
                    }

                    <!-- Notification without a link -->
                    @if (!message.link) {
                        <div class="notification-container">
                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                        </div>
                    }
                </div>

                <!-- Notification content template -->
                <ng-template #notificationContent>
                    <!-- Icon -->
                    <div class="notification-content-template-icon">
                        <mat-icon class="icon-size-5">message</mat-icon>
                    </div>
                    <!-- Title and description -->
                    <div style="display: flex; flex: 1 1 auto; flex-direction: column">
                        @if (message.username) {
                            <div class="notification-content-template-title" [innerHTML]="message.username"></div>
                        } 
                        @if (message.message) {
                            <div class="notification-content-template-message" [innerHTML]="message.message"></div>
                        }
                    </div>
                </ng-template>
            }

            <!-- No notifications -->
            @if (!messages || !messages.length) {
            <div class="no-notification-content">
                <!-- <div
                        class="flex h-14 w-14 flex-0 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-600">
                        <mat-icon class="text-primary-700 dark:text-primary-50" >notifications</mat-icon>
                    </div> -->
                <div class="no-notification-title">Nessun messaggio da leggere</div>
                <div class="no-notification-subtitle">
                    Quando avrai un messaggio da leggere comparirà in questa sezione.
                </div>
            </div>
            }
        </div>
    </div>
</ng-template>
